import { defineComponent as r } from "vue";
import n from "./td-longtail-vue-components3.js";
import t from "./td-longtail-vue-components5.js";
import s from "./td-longtail-vue-components282.js";
const c = /* @__PURE__ */ r({
  __name: "gdpr-permission-layer",
  setup(p, { expose: o }) {
    const e = () => {
      window.utag?.gdpr?.showConsentPreferences && window.utag.gdpr.showConsentPreferences();
    };
    return o({ onSettingsReset: e }), { __sfc: !0, onSettingsReset: e, LinkButton: n, Paragraph: t, NoAccessIcon: s };
  }
});
export {
  c as default
};
